module.exports = __webpack_public_path__ + "media/assets/img/flags/ar-AR-d865c98608f108cf94355b249931bc40.png";